import script from "./transportInvoiceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./transportInvoiceDetail.vue?vue&type=script&setup=true&lang=js"

import "./transportInvoiceDetail.vue?vue&type=style&index=0&id=04b54fde&lang=less"

const __exports__ = script;

export default __exports__